export const WARNING = '#EC2D5B';
export const GREY_900 = '#0d0115';
export const GREY_800 = '#0d0115';
export const GREY_700 = '#290340';
export const GREY_600 = '#7C18D3';
export const GREY_400 = '#FFFFFF';
